import React from 'react';
import {
  Banner,
  Tile,
  Field,
  Form,
  FormSection,
  Heading,
  NewCheckbox,
  NewDatePicker,
  NewFormSection,
  NewInput,
  NewRadio,
  NewSelect,
  NewTable,
  NewTypeahead,
  SelectableList,
  Status,
  Text,
  VStack,
} from '@carta/ink';
import ExposeDescribe from '../components/ExposeDescribe';

const NegativeExpose = () => {
  const [typeaheadValue1, setTypeaheadValue1] = React.useState('error');
  const typeaheadOptionLabel = option => option.label;
  const typeaheadOptions = [
    { label: 'email@email.com' },
    { label: 'another@email.com' },
    { label: 'random@person.com' },
  ];
  const typeaheadFilteredOptions = value => typeaheadOptions.filter(option => option.label.includes(value));
  const [datePickerValue, setDatePickerValue] = React.useState('');

  return (
    <ExposeDescribe
      id="Negative elements visual check"
      name="Negative elements visual check"
      key="Negative elements visual check"
    >
      <VStack spacing="xlarge">
        <Tile>
          <Heading variant="heading-2">NewInput</Heading>
          <NewInput invalid />
        </Tile>

        <Tile>
          <Heading variant="heading-2">NewRadio</Heading>
          <NewRadio id="radio-base" name="new-radio-group-base2" value="4" label="Label" invalid />
          <NewRadio id="radio-base" name="new-radio-group-base2" value="4" label="Label" invalid checked />
        </Tile>

        <Tile>
          <Heading variant="heading-2">NewCheckbox</Heading>
          <NewCheckbox id="newcheckbox-invalid" label="Label" invalid />
          <NewCheckbox id="newcheckbox-invalid" label="Label" invalid checked />
        </Tile>

        <Tile>
          <Heading variant="heading-2">NewTypeahead</Heading>
          <NewTypeahead
            id="typeahead-1"
            value={typeaheadValue1}
            onChange={(_, { value }) => setTypeaheadValue1(value)}
            options={typeaheadOptions}
            optionLabel={typeaheadOptionLabel}
            filterOptions={typeaheadFilteredOptions}
            input={props => <NewInput {...props} id="typeahead-input-1" />}
          />
        </Tile>

        <Tile>
          <Heading variant="heading-2">NewDatePicker</Heading>
          <NewDatePicker
            id="datepicker-4"
            value={datePickerValue}
            onChange={(_, { value }) => setDatePickerValue(value)}
            input={props => <NewInput {...props} invalid />}
          />
        </Tile>

        <Tile>
          <Heading variant="heading-2">Field with input</Heading>
          <Field
            label="Label"
            error="Error message"
            isRequired
            isStacked
            isFull
            htmlFor="stacked-full-field-with-helpers"
          >
            <NewInput id="stacked-full-field-with-helpers-1" invalid />
          </Field>
        </Tile>

        <Tile>
          <Heading variant="heading-2">Stacked full Field with input</Heading>
          <Field label="Label" error="Error message" isRequired isFull htmlFor="stacked-full-field-with-helpers">
            <NewInput id="stacked-full-field-with-helpers-2" invalid />
          </Field>
        </Tile>

        <Tile>
          <Heading variant="heading-2">FormSection</Heading>
          <FormSection
            title="Company info"
            subtitle="We are legally required to have this info on file for customers."
            errors={['Your legal entity name and your Certificate of Incorporation information must match.']}
          />
        </Tile>

        <Tile>
          <Heading variant="heading-2">NewFormSection</Heading>
          <NewFormSection>
            <NewFormSection.Title>Company info</NewFormSection.Title>
            <NewFormSection.Subtitle>
              We are legally required to have this info on file for customers
            </NewFormSection.Subtitle>
            <NewFormSection.Error>
              Your legal entity name and your Certificate of Incorporation information must match
            </NewFormSection.Error>
          </NewFormSection>
        </Tile>

        <Tile>
          <Heading variant="heading-2">Banner</Heading>
          <Banner text="Error message" type="error" />
        </Tile>

        <Tile>
          <Heading variant="heading-2">Status</Heading>
          <Status variant="feedback-negative" primaryText="Error message" secondaryText="Something went wrong" />
        </Tile>

        <Tile>
          <Heading variant="heading-2">Status mini</Heading>
          <NewTable>
            <NewTable.Head>
              <NewTable.Row>
                <NewTable.HeadCell>Stakeholder</NewTable.HeadCell>
                <NewTable.HeadCell>Protocol #</NewTable.HeadCell>
                <NewTable.HeadCell>Status</NewTable.HeadCell>
              </NewTable.Row>
            </NewTable.Head>
            <NewTable.Body>
              <NewTable.Row>
                <NewTable.Cell>Emily Wilson</NewTable.Cell>
                <NewTable.Cell>1213243</NewTable.Cell>
                <NewTable.Cell>
                  <Status variant="feedback-negative" isMini isCell label="Error" />
                </NewTable.Cell>
              </NewTable.Row>
            </NewTable.Body>
          </NewTable>
        </Tile>

        <Tile>
          <Heading variant="heading-2">Vertical radio SelectableList</Heading>
          <SelectableList
            id="selectablelist-invalid-sample-1"
            options={[
              {
                id: 'selectablelist-invalid-1',
                value: 'selectablelist-invalid-1',
                isInvalid: true,
                content: (
                  <>
                    <Text variant="body-2" trim>
                      Primary text
                    </Text>
                    <Text variant="body-3-feedback-neutral" trim>
                      SelectableList secondary text
                    </Text>
                  </>
                ),
              },
              {
                id: 'selectablelist-invalid-2',
                value: 'selectablelist-invalid-2',
                isInvalid: true,
                content: (
                  <>
                    <Text variant="body-2" trim>
                      Primary text
                    </Text>
                    <Text variant="body-3-feedback-neutral" trim>
                      SelectableList secondary text
                    </Text>
                  </>
                ),
              },
            ]}
            value="selectablelist-invalid-2"
          />
        </Tile>

        <Tile>
          <Heading variant="heading-2">Horizontal radio SelectableList</Heading>
          <SelectableList
            id="selectablelist-invalid-sample-2"
            isHorizontal
            options={[
              {
                id: 'selectablelist-invalid-3',
                value: 'selectablelist-invalid-3',
                isInvalid: true,
                content: (
                  <>
                    <Text variant="body-2" trim>
                      Primary text
                    </Text>
                    <Text variant="body-3-feedback-neutral" trim>
                      SelectableList secondary text
                    </Text>
                  </>
                ),
              },
              {
                id: 'selectablelist-invalid-4',
                value: 'selectablelist-invalid-4',
                isInvalid: true,
                content: (
                  <>
                    <Text variant="body-2" trim>
                      Primary text
                    </Text>
                    <Text variant="body-3-feedback-neutral" trim>
                      SelectableList secondary text
                    </Text>
                  </>
                ),
              },
            ]}
            value="selectablelist-invalid-4"
          />
        </Tile>

        <Tile>
          <Heading variant="heading-2">Vertical multi select SelectableList</Heading>
          <SelectableList
            id="selectablelist-multi-select-invalid-1"
            multiSelect
            options={[
              {
                id: 'multiselect-selectablelist-1',
                value: false,
                isInvalid: true,
                content: (
                  <>
                    <Text variant="body-2" trim>
                      Primary text
                    </Text>
                    <Text variant="body-3-feedback-neutral" trim>
                      SelectableList secondary text
                    </Text>
                  </>
                ),
              },
              {
                id: 'multiselect-selectablelist-2',
                value: true,
                isInvalid: true,
                content: (
                  <>
                    <Text variant="body-2" trim>
                      Primary text
                    </Text>
                    <Text variant="body-3-feedback-neutral" trim>
                      SelectableList secondary text
                    </Text>
                  </>
                ),
              },
            ]}
            value="multiselect-selectablelist-2"
          />
        </Tile>

        <Tile>
          <Heading variant="heading-2">Horizontal multi select SelectableList</Heading>
          <SelectableList
            id="selectablelist-multi-select-invalid-2"
            multiSelect
            isHorizontal
            options={[
              {
                id: 'multiselect-selectablelist-3',
                value: false,
                isInvalid: true,
                content: (
                  <>
                    <Text variant="body-2" trim>
                      Primary text
                    </Text>
                    <Text variant="body-3-feedback-neutral" trim>
                      Selectablelist secondary text
                    </Text>
                  </>
                ),
              },
              {
                id: 'multiselect-selectablelist-4',
                value: true,
                isInvalid: true,
                content: (
                  <>
                    <Text variant="body-2" trim>
                      Primary text
                    </Text>
                    <Text variant="body-3-feedback-neutral" trim>
                      Selectablelist secondary text
                    </Text>
                  </>
                ),
              },
            ]}
          />
        </Tile>

        <Tile>
          <Heading variant="heading-2">Editable table configurations</Heading>
          <Form id="form-form-1" onSubmit={() => alert('Profile updated!')}>
            <Field isStacked error="Error message">
              <NewTable data-testid="newtable-buttons">
                <NewTable.Head>
                  <NewTable.Row>
                    <NewTable.HeadCell>Label</NewTable.HeadCell>
                    <NewTable.HeadCell>Value</NewTable.HeadCell>
                  </NewTable.Row>
                </NewTable.Head>
                <NewTable.Body>
                  <NewTable.Row>
                    <NewTable.Cell preset="editable">
                      <NewInput value="Person" />
                    </NewTable.Cell>
                    <NewTable.Cell preset="editable">
                      <NewInput type="number" value="5" invalid />
                    </NewTable.Cell>
                  </NewTable.Row>
                </NewTable.Body>
              </NewTable>
            </Field>
          </Form>
        </Tile>

        <Tile>
          <Heading variant="heading-2">Editable table configurations</Heading>
          <NewTable>
            <NewTable.Head>
              <NewTable.Row>
                <NewTable.HeadCell>
                  <NewCheckbox id="select-all-with-helpers" />
                </NewTable.HeadCell>
                <NewTable.HeadCell width="160px">Stakeholder</NewTable.HeadCell>
                <NewTable.HeadCell>Security</NewTable.HeadCell>
                <NewTable.HeadCell>Email</NewTable.HeadCell>
                <NewTable.HeadCell>Country</NewTable.HeadCell>
                <NewTable.HeadCell align="right">Exercise date</NewTable.HeadCell>
              </NewTable.Row>
            </NewTable.Head>
            <NewTable.Body>
              <NewTable.Row key="452">
                <NewTable.Cell preset="checkbox">
                  <NewCheckbox />
                </NewTable.Cell>
                <NewTable.Cell>Person</NewTable.Cell>
                <NewTable.Cell preset="editable">
                  <NewInput id="newtable-input-2" invalid />
                </NewTable.Cell>
                <NewTable.Cell preset="editable">
                  <NewInput id="newtable-input-3" invalid />
                </NewTable.Cell>
                <NewTable.Cell preset="editable">
                  <NewSelect id="new-table-select-1" name="new-table-select-1">
                    <NewSelect.Option value="" />
                    <NewSelect.Option value="australia">Australia</NewSelect.Option>
                    <NewSelect.Option value="brazil">Brazil</NewSelect.Option>
                    <NewSelect.Option value="canada">Canada</NewSelect.Option>
                    <NewSelect.Option value="united-states">United States</NewSelect.Option>
                  </NewSelect>
                </NewTable.Cell>
                <NewTable.Cell preset="editable">
                  <NewInput id="newtable-input-4" />
                </NewTable.Cell>
              </NewTable.Row>
            </NewTable.Body>
          </NewTable>
        </Tile>
      </VStack>
    </ExposeDescribe>
  );
};

export default NegativeExpose;
